import { apiClient, handleResponse, handleError } from '../helpers';
import { api } from '../constants';
import { createRequestCacheKey, fetchWithCache } from '../helpers/requestCache';

const APP_CONFIGS_TTL_MS = 30 * 60 * 1000;
const appConfigsCacheKey = () => createRequestCacheKey('config', 'app-configs');

export const configService = {
    fetchAppConfigs
};

function fetchAppConfigs() {
    return fetchWithCache({
        key: appConfigsCacheKey(),
        ttlMs: APP_CONFIGS_TTL_MS,
        loader: () => apiClient.get(api.config.fetchAppconfigs)
            .then(handleResponse)
            .then(data => data),
    })
        .catch(error => handleError(error.response));
}
